<template>
  <div class="page-footer">
    <section class="footer-color-bar">
      <h3>取之于民，服务于民</h3>
      <p>致力开发便民软件，人民需要什么，我们就开发什么</p>
    </section>
    <section class="footer-info">
      <b-container fluid="xl">
        <b-row>
          <b-col cols="6" xl="4" md="4" sm="6" class="info-item">
            <header>CONTACTS</header>

            <p class="mb-4">广州市天河区科华街1号301至353室自编B181房</p>

            <div class="blod-info mb-4">
              <img src="../assets/imgs/phone.png" alt="" />
              020-62683334
            </div>

            <div class="blod-info">
              <img src="../assets/imgs/mail.png" alt="" />
              1768422205@@qq.com
            </div>
            <br/>
            <a href="https://beian.miit.gov.cn/" style="text-decoration:none; color:#000000;" target="view_window"> 粤ICP备2020089004号-1</a>
          </b-col>

          <b-col cols="6" xl="4" md="4" sm="6" class="info-item">
            <header>Company</header>

            <p> 广州一生八信息科技有限公司 </p>

          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>

<style scoped lang="scss">
  .page-footer {
    padding-bottom: 86px;
    .footer-color-bar {
      height: 195px;
      background: linear-gradient(165deg, #272a35, #272a35);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 20px;

      h3 {
        font-size: 22px;
        font-weight: 700;
        color: #ffffff;
      }

      p {
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.4;
        margin-top: 13px;
      }
    }

    .footer-info {
      padding-top: 78px;

      .info-item {
        header {
          font-size: 18px;
          font-weight: 700;
          color: #000000;
          margin-bottom: 50px;
        }

        p {
          font-size: 15px;
          font-weight: 400;
          color: #000000;
        }

        .blod-info {
          display: flex;
          align-items: center;
          font-size: 15px;
          font-weight: 700;
          color: #000000;

          img {
            width: 18px;
            margin-right: 10px;
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  @media (max-width: 768px) {
    .footer-color-bar {
      text-align: center;
      h3 {
        font-size: 16px !important;
      }
      p {
        font-size: 12px !important;
      }
    }
  }
</style>
